import React from 'react';
import { TbPointFilled } from "react-icons/tb";

const CardDetailProject = ({title, className, size, ID, id, competences, apropos, presentation, price, duration, publicationDate, head, cardPadding, objectif}) => {
  return (
    <div
      className={`card bg-transparent rounded-2xl shadow border my-4 p-8 ${cardPadding}`}
    >
      <div className="flex flex-col gap-3">
        <div className={head}>
          <div className={`flex flex-col gap-3`}>
            <div className={className}>
              <h2 className={size}>{title}</h2>
            </div>
            {presentation && (
              <div className="flex flex-col md:flex-row  gap-2 items-start md:items-center font-inter ">
                <span className="text-sm bg-orange px-2 py-1 font-semibold text-white rounded-badge">
                  Ouvert
                </span>
                <span className="inline-flex text-sm items-center justify-center">
                  Publié il y'a {publicationDate}
                </span>
                <TbPointFilled className='hidden md:block' size={8} />
                <span className="text-sm">
                  Se termine dans {duration} jours
                </span>
              </div>
            )}
            {objectif && <div>
              {objectif}
            </div>}
          </div>
          {presentation && (
            <div className="flex flex-col gap-5 items-end">
              <h1 className="font-inter text-3xl font-bold text-orange">
                {price} FCFA
              </h1>
              <p className="text-sm font-inter">Payé à la validation</p>
            </div>
          )}
        </div>
        {ID && <p className="text-[13px] font-inter">ID du projet : #{id}</p>}
        {competences?.length != 0 ? (
          <div className="flex gap-3 flex-wrap">
            {competences?.map((competence, i) => (
              <span
                className="border border-orange rounded text-xs py-1 px-3"
                key={i}
              >
                {competence?.type_competence}
              </span>
            ))}
          </div>
        ) : (
          <p className="text-gris italic test-xs">Aucune compétence requise !</p>
        )}
        {apropos && (
          <div className="flex gap-4 items-center font-inter">
            {apropos?.map((propo, i) => (
              <div className="flex gap-1 text-[10px] items-center" key={i}>
                <span>{propo?.icon}</span>
                <span>{propo?.text}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default CardDetailProject
